import { configureStore } from "@reduxjs/toolkit";
import usuarioSlice from "./slices/usuario.slice";
import sidebarRoutesSlice from "./slices/sidebarRoutes.slice";  
import notificationsReducer from "./slices/notificacions.slice";

export default configureStore({
  reducer: {
    usuario: usuarioSlice,
    sidebarRoutes: sidebarRoutesSlice,
    notifications: notificationsReducer
  }
})